import { deduplicateFragments } from "@xingternal/crate-core-graphql-fragment-deduplicator";
const UseLoginStateDocument = deduplicateFragments({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "UseLoginState" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "loginState" } }
              ]
            }
          }
        ]
      }
    }
  ]
});
export {
  UseLoginStateDocument
};
